import React, { Component } from 'react'
import { Grid } from '../../../node_modules/@material-ui/core';
import Card from '../../../node_modules/@material-ui/core/Card';
import CardContent from '../../../node_modules/@material-ui/core/CardContent';
import CardMedia from '../../../node_modules/@material-ui/core/CardMedia';
import Typography from '../../../node_modules/@material-ui/core/Typography';

import Menu from './includes/Menu'
import Award01 from '../assets/images/award-01.png';
import Award02 from '../assets/images/award-02.png';
import Award03 from '../assets/images/award-03.png';


import CardActions from '../../../node_modules/@material-ui/core/CardActions';
import { Link } from 'react-router-dom'
import Button from '../../../node_modules/@material-ui/core/Button';



const lang = '';

class Award extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '獎項殊榮',
      'sc': '奖项殊荣',
      'en': 'Awards & Recognitions'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  getLink(page){
    return (this.lang) ? '/' + this.lang + '/' + page : '/' + page;
  }

  render(){
    return(
      AwardJSX(this)
    );
  }
}

const AwardJSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className="main-content-container">
      <div className='main-content-inner-wrapper award'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '獎項殊榮',
                    'sc': '奖项殊荣',
                    'en': 'Awards & Recognitions'
                })
              }
            </span>
          </Grid>
        </Grid>

        <div className='award-content-container'>
          <Grid container spacing={0}>
            <div className='award-desc'>
              <Grid item>
                <p>
                  {
                    ctx.getLangText({
                        'tc': '匯寶資本集團憑藉頂尖金融科技、卓越服務、勇於創新精神，得到了業界和客戶的高度認同，多年來屢獲殊榮。',
                        'sc': '汇宝资本集团凭借顶尖金融科技、卓越服务、勇于创新精神，得到了业界和客户的高度认同，多年来屡获殊荣。',
                        'en': `Winning high recognition from the industry and clients, FxHB Group has received numerous awards for its top fintech, excellent services and spirit of innovation throughout the years.`
                    })
                  }
                </p>
              </Grid>
            </div>

            <Grid container spacing={32}>
              <Grid container item xs={12} sm={6} md={4} lg={4}>
                <Card className="material-card">
                  <CardMedia className="card-media" image={Award01} title="Contemplative Reptile" style={{width:'150px', height:'190px', margin:'0 auto'}} />
                  <CardContent className="material-CardContent">
                    <span className='theme-color'>
                      {
                        ctx.getLangText({
                            'tc': '2016 / 2017 年度',
                            'sc': '2016 / 2017 年度',
                            'en': `Bullion Value Added`
                        })
                      }
                      <br/>
                      {
                        ctx.getLangText({
                            'tc': '貴金屬行業服務大獎',
                            'sc': '贵金属行业服务大奖',
                            'en': `Service Award 2016/2017`
                        })
                      }
                    </span>
                  </CardContent>
                </Card>
              </Grid>
              <Grid container item xs={12} sm={6} md={4} lg={4}>
                <Card className="material-card">
                  <CardMedia className="card-media" image={Award02} title="Contemplative Reptile" style={{width:'150px', height:'190px', margin:'0 auto'}} />
                  <CardContent className="material-CardContent">
                    <span className='theme-color'>
                      {
                        ctx.getLangText({
                            'tc': '2015 年度',
                            'sc': '2015 年度',
                            'en': `2015 Top 10 Gold`
                        })
                      }
                      <br/>
                      {
                        ctx.getLangText({
                            'tc': '十佳黃金交易平台',
                            'sc': '十佳黄金交易平台',
                            'en': `Trading Platform`
                        })
                      }
                    </span>
                  </CardContent>
                </Card>
              </Grid>
              <Grid container item xs={12} sm={6} md={4} lg={4}>
                <Card className="material-card">
                  <CardMedia className="card-media" image={Award03} title="Contemplative Reptile" style={{width:'150px', height:'190px', margin:'0 auto'}} />
                  <CardContent className="material-CardContent">
                    <span className='theme-color'>
                      {
                        ctx.getLangText({
                            'tc': '第13屆',
                            'sc': '第13届',
                            'en': `Best Bullion`
                        })
                      }
                      <br/>
                      {
                        ctx.getLangText({
                            'tc': '最佳黃金交易平台',
                            'sc': '最佳黄金交易平台',
                            'en': `Trading Platform Awards`
                        })
                      }
                    </span>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default Award



// WEBPACK FOOTER //
// ./src/components/pages/AwardRecognitions.js